module.exports = __webpack_public_path__ + "Panton-Regular.c0898d3b42d7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-Regular.ttf
// module id = ./src/styles/fonts/Panton-Regular.ttf
// module chunks = 21